import { combineReducers } from 'redux';
import { requestReducer } from './request-feature';
import { userReducer } from "./user-feature";
import taskReducer from './task-feature';

export const rootReducer = combineReducers({ user: userReducer, requests: requestReducer, tasks: taskReducer});

export default rootReducer;